import { render, staticRenderFns } from "./travelIndusry.vue?vue&type=template&id=50de4ba6"
import script from "./travelIndusry.vue?vue&type=script&lang=js"
export * from "./travelIndusry.vue?vue&type=script&lang=js"
import style0 from "./travelIndusry.vue?vue&type=style&index=0&id=50de4ba6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports